import React, { Component } from "react";
import adi from "../images/adi.jpg";
class Projects extends Component {
  render() {
    return (
      <>
        <div>
          <h2 style={{ display: "flex", justifyContent: "center" }}>
            Projects
          </h2>
        </div>
      </>
    );
  }
}

export default Projects;
